// extracted by mini-css-extract-plugin
module.exports =  {"tabWrapper":"tabWrapper___1gUuP","photoWrapper":"photoWrapper___b6V8j","textWrapper":"textWrapper___9JDIh"};